import { Component, Input, OnInit } from '@angular/core';
import { debounceTime } from 'rxjs/operators';
import { I18ConfigService } from 'src/app/services/shared/I18-config.service';
import { AccountService } from 'src/app/services/user/account.service';
import { HelperService } from 'src/app/services/helper/helper.service';

@Component({
  selector: 'user-card',
  templateUrl: './user-card.component.html',
  styleUrls: ['./user-card.component.scss'],
})
export class UserCardComponent implements OnInit {
  @Input() userInfo: any;
  @Input() isExpire: any;
  public expiryDate: any;
  constructor(
    private accountService: AccountService,
    private i18Service: I18ConfigService,
    private helperService: HelperService
  ) {}

  ngOnInit() {
    const storedUserInfo = this.accountService.getUserInfo();
    const storedCurrency = this.i18Service.getCurrency();

    this.expiryDate =this.helperService.convertToLocalTimezoneDate(this.userInfo?.subscribedTier?.expiryDate);

    if (
      !storedUserInfo ||
      storedUserInfo.tier !== this.userInfo.subscribedTier?.tier
    ) {
      this.accountService.setUserInfo({
        name: this.userInfo.fullName || this.userInfo.firstName,
        email: this.userInfo.email,
        profileImg: this.userInfo.profileImg,
        userId: this.userInfo.id,
        tier: this.userInfo.subscribedTier?.tierTitle || this.userInfo.subscribedTier?.tier || 'LITE',
        mobileNo: this.userInfo.mobileNo || '',
        dob: this.userInfo.dob ? this.convertTimestampToDateString(this.userInfo.dob) : '',
      });
    }
    if (
      (!storedCurrency || storedCurrency === '') &&
      this.userInfo?.subscribedTier?.currency
    ) {
      this.i18Service.setCurrency(this.userInfo?.subscribedTier?.currency);
    }
  }

  convertTimestampToDateString(timestamp: number): string {
    const date = new Date(timestamp);
    return date.toLocaleDateString('en-CA');
  }
}
